import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchClientData as rdxFetchClientData,
  updateClientData as rdxUpdateClientData,
  IFetchClientDataPayload,
  selectClientData,
  IClientData,
} from '../redux/clientData'
import getQueryParams from '../utils/getQueryParams'

export default function useClientData() {
  const dispatch = useDispatch()

  const { data: clientData, isLoading, error } = useSelector(selectClientData)

  const { sessionToken } = getQueryParams({ url: window.location.search })

  const fetchClientData = useCallback(({ userId, sessionToken, middleware }: IFetchClientDataPayload) => {
    dispatch(rdxFetchClientData({ userId, sessionToken, middleware }))
  }, [])

  const setClientDataToLocalStorage = useCallback(() => {
    localStorage.setItem(`@YaloWebview:${sessionToken}`, JSON.stringify(clientData))
  }, [sessionToken, clientData])

  const getClientDataFromLocalStorage = useCallback(() => {
    const stringifiedClientData = localStorage.getItem(`@YaloWebview:${sessionToken}`)

    if (stringifiedClientData) {
      const parsedClientData = JSON.parse(stringifiedClientData)
      dispatch(rdxUpdateClientData(parsedClientData as IClientData))
    }
  }, [clientData, sessionToken])

  const removeClientDataFromLocalStorage = useCallback(() => {
    localStorage.removeItem(`@YaloWebview:${sessionToken}`)
  }, [sessionToken])

  return {
    getClientDataFromLocalStorage,
    setClientDataToLocalStorage,
    removeClientDataFromLocalStorage,
    clientData,
    isLoading,
    fetchClientData,
    error,
  }
}
